"use client";

import React from "react";
import { Instagram, Facebook, Twitter, MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="232961" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-col gap-4">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm font-default text-muted-foreground hover:text-primary transition-colors duration-300">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const socialLinks = [{
  icon: Instagram,
  href: "#",
  label: "Instagram"
}, {
  icon: Facebook,
  href: "#",
  label: "Facebook"
}, {
  icon: Twitter,
  href: "#",
  label: "Twitter"
}];
export default function SiteFooter() {
  return <section id="pie-de-página" className="dark bg-background text-foreground pt-16 pb-8 overflow-hidden relative">
      <div className="container mx-auto px-6 md:px-8 lg:px-12 relative z-10">
        {}
        <Separator className="bg-primary/30 mb-16 h-[1px] w-full" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647820/img/arrels_industrial_logo.png" alt="ARRELS Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sm font-default text-muted-foreground leading-relaxed max-w-xs">
              Potencia agrícola y confianza en cada terreno. Arriendo de maquinaria pesada, tractores de alta gama y grúas horquilla 4x4 para proyectos de alto rendimiento.
            </p>
          </div>

          {}
          <div className="flex flex-col">
            <h3 className="font-default text-lg font-bold mb-6 tracking-wider uppercase text-primary">Explorar</h3>
            <MenuProvider menu_id="17">
              <FooterNav />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col">
            <h3 className="font-default text-lg font-bold mb-6 tracking-wider uppercase text-primary">Maquinaria</h3>
            <ul className="flex flex-col gap-4 text-sm font-default text-muted-foreground">
              <li><Link to="#" className="hover:text-primary transition-colors">Tractores 70hp - 110hp</Link></li>
              <li><Link to="#" className="hover:text-primary transition-colors">Grúas Horquilla 4x4</Link></li>
              <li><Link to="#" className="hover:text-primary transition-colors">Equipos Autocargables</Link></li>
              <li className="flex gap-4 mt-2">
                {socialLinks.map((social, i) => {
                const Icon = social.icon;
                return <Link key={i} to={social.href} data-index={i} className="group p-2 -ml-2 rounded-sm hover:bg-primary/10 transition-colors duration-300" aria-label={social.label}>
                      <Icon className="size-5 text-muted-foreground group-hover:text-primary transition-colors duration-300" strokeWidth={1.5} />
                    </Link>;
              })}
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col">
            <h3 className="font-default text-lg font-bold mb-6 tracking-wider uppercase text-primary">Contacto</h3>
            <ul className="flex flex-col gap-4 text-sm font-default text-muted-foreground">
              <li className="flex items-start gap-3">
                <MapPin className="size-4 mt-0.5 shrink-0 text-primary" strokeWidth={2} />
                <span>ZLos Lingues, San Fernando, O'Higgins<br />Despacho a toda la región</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-4 shrink-0 text-primary" strokeWidth={2} />
                <Link to="tel:+56912345678" className="hover:text-primary transition-colors">+56986282093
<br />+56999294934</Link>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-4 shrink-0 text-primary" strokeWidth={2} />
                <Link to="mailto:contacto@arrels.cl" className="hover:text-primary transition-colors">arriendoarrels@gmail.com</Link>
              </li>
            </ul>
          </div>
        </div>

        {}
        <div className="pt-8 border-t border-border/20 flex flex-col items-center justify-center relative">
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 pointer-events-none select-none">
            <span className="font-serif text-[120px] md:text-[180px] lg:text-[240px] leading-none text-foreground opacity-[0.03] tracking-tighter">
              ARRELS
            </span>
          </div>
          <p className="text-[10px] uppercase tracking-[0.3em] font-default text-muted-foreground text-center relative z-10">
            © {new Date().getFullYear()} ARRELS MAQUINARIA. SOLUCIONES DE CAMPO.
          </p>
        </div>
      </div>
    </section>;
}